import { Transform } from 'class-transformer'
import { IsArray, IsBoolean, IsNotEmpty, IsNumber, IsString, MaxLength, MinLength } from 'class-validator'

export class GenerateFarmTokenDto {
  @IsArray()
  @IsNotEmpty()
  @Transform(({ value }) => {
    // Handle both array and single value (from FormData)
    if (Array.isArray(value)) {
      return value.map((v) => (typeof v === 'string' ? parseInt(v, 10) : v))
    }
    return typeof value === 'string' ? [parseInt(value, 10)] : [value]
  })
  @IsNumber({}, { each: true })
  farmIds!: number[]

  @IsString()
  @IsNotEmpty()
  @MinLength(1)
  @MaxLength(4000)
  body!: string

  @Transform(({ value }) => {
    if (typeof value === 'string') {
      return value === 'true'
    }
    return value
  })
  @IsBoolean()
  @IsNotEmpty()
  sendLink!: boolean
}
